import {StyleSheet} from 'react-native';

export default StyleSheet.create({
  btnValiderOuterProfil: {
    display: 'flex',
    minWidth: '100%',
    backgroundColor: '#0f579e',
    borderRadius: 30,
    height: 50,
    paddingHorizontal: 30,
    shadowColor: 'rgba(15, 87, 158, 0.9)',
    shadowOffset: {
      width: 1,
      height: 2,
    },
    shadowOpacity: 0.4,
    shadowRadius: 7,
    elevation: 5,
    marginVertical: 8,
  },
  profilHead: {
    height: 50,
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
  },
  Headevide: {
    flex: 1,
    alignItems: 'flex-end',
  },
  textError: {
    color: '#f00',
    fontSize: 14,
  },
  ProfilImageCenter: {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  ProfilImage: {
    width: 100,
    height: 100,
    borderRadius: 50,
    resizeMode: 'cover',
  },
  EditProfil: {
    width: 24,
    height: 24,
    resizeMode: 'cover',
  },
  btnContainerProfil: {
    maxWidth: 400,
    marginHorizontal: 'auto',
    flex: 0.8,
    flexDirection: 'row',
    marginVertical: 20,
  },
  btnContainerProfilP: {
    maxWidth: 400,
    marginVertical: 20,
    flexDirection: 'row',
    minHeight: 60,
  },
  labelStyle: {
    color: 'rgba(29, 92, 66, 1)',
    fontSize: 11,
    fontWeight: '700',
    marginTop: 10,
    marginBottom: 5,
  },
  btnContainerProfil11: {
    flexDirection: 'row',
    marginBottom: 20,
  },
});
